import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import "./OpalAnnouncementList.css";
import OpalScrollSpy from "../../../OpalScrollSpy/OpalScrollSpy";

const OpalAnnouncementList = ({ show, onHide, items }) => {

    const sortedItems = [...(items || [])].sort((a, b) => b.Priority - a.Priority);

    return (
        <Modal className="opal-announcement-list" show={show} onHide={onHide} centered>
            <Modal.Header>
                Announcements
            </Modal.Header>
            <Modal.Body>
                {sortedItems.length === 0 ? (
                    <div className="text-muted">No announcements available.</div>
                ) : (
                    <OpalScrollSpy reminders={sortedItems} asc={true} />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default OpalAnnouncementList;
